import {
  useCheckLogin,
  useGetActivePatients,
  useGetMessageCorrespondents,
  useGetUnreadMessage,
} from '_api';
import { MessageCorrespondents } from '_api/types';
import { useMemo } from 'react';

const useMessage = () => {
  const { data: account } = useCheckLogin();
  const { data: messageCorrespondents } = useGetMessageCorrespondents();
  const { data: unreadMessages } = useGetUnreadMessage();
  const { data: allPatients } = useGetActivePatients({
    page: 0,
    size: 1000,
    withAlerts: false,
  });

  const correspondents = useMemo(
    () =>
      messageCorrespondents ? messageCorrespondents : ([] as MessageCorrespondents[]),
    [messageCorrespondents],
  );

  const unreadMessageIdList = useMemo(
    () => (unreadMessages ? unreadMessages.map((mes) => mes.sender.id) : []),
    [unreadMessages],
  );

  const therapistPatients = useMemo(() => {
    if (allPatients && account) {
      return allPatients.filter((patient) =>
        patient.therapists.some(({ id }) => id === account.id),
      );
    }
    return [];
  }, [account]);

  const patientGuardianMessageOptions = useMemo(
    () =>
      therapistPatients.map((patient) => ({
        name: patient.guardian.id,
        description: `${patient.guardian.firstName} ${patient.guardian.lastName} - ${patient.firstName} ${patient.lastName}`,
      })),
    [therapistPatients],
  );

  const getPatientsByGuardian = (guardianId: number | undefined) => {
    if (therapistPatients && guardianId) {
      return therapistPatients.filter((patient) => patient.guardian.id == guardianId);
    }
    return [];
  };

  return {
    correspondents,
    getPatientsByGuardian,
    patientGuardianMessageOptions,
    therapistPatients,
    unreadMessageIdList,
  };
};

export default useMessage;
